import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'child-cell',
    template: `<span><button *ngIf='showDownload' style="margin-top:0px;padding: 1px 3px !important;"  color="link" size="sm" class="waves-light edit-button btn btn-sm" (click)="edit()" >
    <i [ngClass]="showDownload ? 'icon-download' : 'icon-edit'"></i>
</button>
<button *ngIf='showDelete' style="margin-top:0px;padding: 1px 3px !important;"  color="link" size="sm" class="waves-light edit-button btn btn-sm" (click)="delete()" >
    <i [ngClass]="showDelete ? 'icon-delete' : 'icon-settings'"></i>
</button>
<button *ngIf='showEdit' style="margin-top:0px;padding: 1px 3px !important;"  color="link" size="sm" class="waves-light edit-button btn btn-sm" (click)="edit()" >
    <i class='icon-edit'></i>
</button>
<button *ngIf='showFile' style="margin-top:0px;padding: 1px 3px !important;"   color="link" class="waves-light edit-button btn btn-sm"  (click)="FileClick()" >
<i class="fas fa-file-alt"></i>
</button>
</span>`,
    styles: [
    ]
})
export class EditAndDeleteOperationsRenderer implements ICellRendererAngularComp { public params: any;
  showDownload: boolean = false;
  showDelete: boolean = false;
  showEdit: boolean = false;
  showFile: boolean = false;
    agInit(params: any): void {
      this.params = params;
     // item.HasRFI = app.HasRFI;
     // item.HasCorrespondence = app.HasCorrespondence;
      params.data.FileName ? this.showDownload = true : this.showDownload = false;
      params.colDef.IsRequiredDelete ? this.showDelete = true : this.showDelete = false;
      params.colDef.IsRequiredEdit ? this.showEdit = true : this.showEdit = false;
      params.colDef.IsRequiredFile ? this.showFile = true : this.showFile = false;
    }

    public delete() {
        this.params.context.componentParent.deleteRow(this.params)
    }

    public edit() {
        this.params.context.componentParent.editRow(this.params)
    }

    public FileClick() {
        // let calbackfun=  this.params.data.Operations.filter((item)=>{
        //     return item.name===this.params.colDef.CalBackFunctionName;
        //   })[0];
        this.params.context.componentParent.onOperationClick(this.params.colDef.CalBackFunctionName);
    }

    refresh(): boolean {
        return false;
    }
}
